module.exports = __webpack_public_path__ + "img/MAZOVIA.af912407.jpg";